'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'puzzle';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e443';
var svgPathData = ['M32 96l0 176 48 0 0-16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 16 32 0 0-176L32 96zm0 208l0 176 176 0 0-48-16 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l16 0 0-32-48 0-16 0 0-16 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 0 16-16 0-64 0zm144 80c0 8.8 7.2 16 16 16l32 0 16 0 0 16 0 64 176 0 0-176-48 0 0 16c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-16-32 0 0 48 0 16-16 0-32 0c-8.8 0-16 7.2-16 16zM320 32l0 24 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0 24 48 0 16 0 0 16 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 0-16 16 0 48 0 0-144L320 32z', 'M304 0L288 0l0 16 0 56 0 16 16 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0-16 0 0 16 0 56 0 16 16 0 48 0c0 26.5 21.5 48 48 48s48-21.5 48-48l48 0 16 0 0-16 0-176 0-16L496 0 304 0zm32 152c26.5 0 48-21.5 48-48s-21.5-48-48-48l-16 0 0-24 160 0 0 144-48 0-16 0 0 16 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16 0-16-16 0-48 0 0-24 16 0zM16 64L0 64 0 80 0 288 0 496l0 16 16 0 208 0 208 0 16 0 0-16 0-208 0-16-16 0-80 0-16 0 0 16 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-16-16 0-48 0 0-192 0-16-16 0L16 64zM272 320c0 26.5 21.5 48 48 48s48-21.5 48-48l0-16 48 0 0 176-176 0 0-64 0-16-16 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 16 0 0-16 0-48 32 0 0 16zM208 432l0 48L32 480l0-176 64 0 16 0 0-16 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16 16 0 48 0 0 32-16 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l16 0zM80 272l-48 0L32 96l176 0 0 176-32 0 0-16c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPuzzle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;